export default {
  label: 'Español',
  labelMobile: 'ES',
  breadcrumb: {
    home: 'Inicio',
    SimulationsView: 'Simulaciones',
    ResultsView: 'Resultados',
    TracingView: 'Seguimiento',
    GeneralParameterizationView: 'Parametrización general',
    HvoExportsView: 'Exportaciones HVO',
  },
}
